module.exports = __webpack_public_path__ + "img/features-practice.4da9d502.svg";